import { Navigate } from 'react-router-dom';
import { selectedUser } from '../../features/auth/authSlice';
import CodeVerificationForm from '../../features/auth/components/CodeVerificationForm';
import { useAppSelector } from '../../hooks/redux/hooks';

const EmailVerification = () => {
    const { isAuthenticated } = useAppSelector(selectedUser);
    if (!isAuthenticated) {
        return <Navigate replace to='/login' />
    }

    return (
        <>
            <CodeVerificationForm />
        </>
    )
}

export default EmailVerification;